import { Caption } from './Caption';

export type { TypeCaptionProps } from './types';
export default Caption;
